module.exports = __webpack_public_path__ + "img/binance_testnet.47accf89.svg";